/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTHIRDPARTYRELATIONTYPE = {
    Beneficiary: 'BENE',
    Nominee: 'NOMINEE',
    AlternativeBeneficiary: 'ALTBEN',
    Dependant: 'DEPENDT',
    Owner: 'OWNER',
    LifeAssured: 'LIFEASS',
    Addressee: 'ADDRESSEE',
    Guardian: 'GUARDIAN',
    PowerOfAttorney: 'PWRATTRNY',
    Executor: 'EXECUTOR',
    PersonalLegalRepresentative: 'PLREP',
    PreviousProvider: 'PREPROV',
    Payer: 'PAYER',
    Payee: 'PAYEE',
    Trust: 'TRUST',
    Assignee: 'ASSIGNEE',
    Assignor: 'ASSIGNOR',
    Loa3RdParty: 'LOA',
    CuratorBonis: 'CURATORBON',
    Parent: 'PARENT',
    NaturalGuardian: 'NTLGU',
    LegalGuardian: 'LGLGU',
    Cessionary: 'CESSIONARY',
    NomineeForOwnership: 'NOMFOROWN',
    PrincipleLife: 'PRINCIPAL'
} as const;
export type IAPTHIRDPARTYRELATIONTYPE = typeof IAPTHIRDPARTYRELATIONTYPE[keyof typeof IAPTHIRDPARTYRELATIONTYPE];


export function IAPTHIRDPARTYRELATIONTYPEFromJSON(json: any): IAPTHIRDPARTYRELATIONTYPE {
    return IAPTHIRDPARTYRELATIONTYPEFromJSONTyped(json, false);
}

export function IAPTHIRDPARTYRELATIONTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTHIRDPARTYRELATIONTYPE {
    return json as IAPTHIRDPARTYRELATIONTYPE;
}

export function IAPTHIRDPARTYRELATIONTYPEToJSON(value?: IAPTHIRDPARTYRELATIONTYPE | null): any {
    return value as any;
}

